import { makeObservable, observable, action, runInAction, toJS } from 'mobx';
import {
  getShopSettings,
  updateShopSettings
} from '../helpers/api';

class ShopSettingsStore {
  _shopSettings = null;
  _isLoading = false;
  _error = null;
  _successMessage = null;

  constructor() {
    makeObservable(this, {
      _shopSettings: observable,
      _isLoading: observable,
      _error: observable,
      _successMessage: observable,

      loadShopSettings: action,
      updateShopSettings: action,
      setError: action,
      setSuccess: action,
      clearMessages: action
    });
  }

  // Getters
  get shopSettings() {
    return toJS(this._shopSettings);
  }

  get shopName() {
    return this._shopSettings?.name || 'barba';
  }

  get isLoading() {
    return this._isLoading;
  }

  get error() {
    return this._error;
  }

  get successMessage() {
    return this._successMessage;
  }

  // Actions
  setError(error) {
    this._error = error;
  }

  setSuccess(message) {
    this._successMessage = message;
  }

  clearMessages() {
    this._error = null;
    this._successMessage = null;
  }

  async loadShopSettings() {
    this._isLoading = true;
    this._error = null;

    try {
      const data = await getShopSettings();
      runInAction(() => {
        this._shopSettings = data.settings || null;
        this._isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this._error = 'Erro ao carregar configurações';
        this._isLoading = false;
      });
      console.error('Failed to load shop settings:', err);
    }
  }

  async updateShopSettings(settingsData) {
    this._isLoading = true;
    this._error = null;

    try {
      await updateShopSettings(settingsData);
      runInAction(() => {
        this._successMessage = 'Configurações atualizadas com sucesso';
        this._shopSettings = settingsData; // Update local cache
        this._isLoading = false;
      });

      // Force adminStore to reload the settings to update the cached version
      const adminStore = require('./AdminStore').default;
      adminStore._shopSettingsLoaded = false; // Reset the cache flag
      await adminStore.loadShopSettings();

      return true;
    } catch (err) {
      runInAction(() => {
        this._error = err.message || 'Erro ao atualizar configurações';
        this._isLoading = false;
      });
      console.error('Failed to update shop settings:', err);
      return false;
    }
  }
}

const shopSettingsStore = new ShopSettingsStore();
export default shopSettingsStore;